const t = {
  name: "CreditCardSmall",
  dimensions: { width: 20, height: 15 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2">
      <rect x="1" y="1.5" width="18" height="12" rx="2"/>
      <path d="M0 5.5H20" stroke-miterlimit="10"/>
      <path d="M4 9.5H6.72727" stroke-miterlimit="10" stroke-linecap="round"/>
    </g>
  `
};
export {
  t as CreditCardSmall
};
